import { render, staticRenderFns } from "./AllPhoneNumbers.vue?vue&type=template&id=df4b6534&scoped=true"
import script from "./AllPhoneNumbers.vue?vue&type=script&lang=js"
export * from "./AllPhoneNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4b6534",
  null
  
)

export default component.exports